import { useState, useEffect, useRef } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import CustomerReportComponent from "../../component/restaurants/reports/CustomerReportComponent";
import { ReportService } from "../../services/reports-services";
import { message } from "antd";
import useUserStore from "../../stores/store";
import CustomLoader from "../../component/menu/CustomLoader";

export default function CustomerReport() {
  const { user, restaurantId, showNotification, networkCall, setNetworkCall } = useUserStore();
  const [customerSummary, setCustomerSummary] = useState({});
  const [customerReportList, setCustomerReportList] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [customerFilter, setCustomerFilter] = useState({
    restaurantId: restaurantId,
    mobileNo: "",
    fromDate: "",
    toDate: "",
    status: "",
  });
  const [isFilterClear, setIsFilterClear] = useState(false);
  const isFetching = useRef(false);

  async function fetchCustomerReportList(filter) {
    setNetworkCall(true);
    try {
      const customers = await ReportService.getCustomerReportList(
        filter,
        user.token.token
      );
      setCustomerReportList(customers.data);
      setPage(customers.page);
      setPerPage(customers.perPage);
      setTotalItem(customers.total);
      setNetworkCall(false);
    } catch (err) {
      message.error("Something went wrong in serverside. Try again later.");
      setNetworkCall(false);
      return;
    }
  }

  /** init **/
  useEffect(() => {
    async function fetchSummaryReport() {
      try {
        const summaryReport = await ReportService.getCustomerReportSummary(
          restaurantId,
          user.token.token
        );
        setCustomerSummary(summaryReport.data);
      } catch (error) {
        console.error("Error fetching report:", error);
        message.error("Something went wrong. Try again later.");
        return;
      }
    }

    if (restaurantId) {
      fetchSummaryReport();
    }
  }, [restaurantId]);

  useEffect(() => {
    async function fetchData() {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const tempFilter = { ...customerFilter, page, perPage };
        await fetchCustomerReportList(tempFilter);
      } catch (err) {
        console.error("Error fetching:", err);
      } finally {
        isFetching.current = false;
      }
    }

    fetchData();
  }, [page, perPage]);

  useEffect(() => {
    async function fetchData() {
      if (isFilterClear) {
        await fetchCustomerReportList(customerFilter);
        setIsFilterClear(false);
      }
    }

    fetchData();
  }, [isFilterClear]);

  function onHandleFilterData() {
    if (page !== 1 || perPage !== 10) {
      setPage(1);
      setPerPage(10);
    }
    const tempFilter = { ...customerFilter, page: 1, perPage: 10 };
    fetchCustomerReportList(tempFilter);
  }

  function onHandlePageChange(page, pageSize) {
    setPage(page);
    setPerPage(pageSize);
  }

  function onHandlePageSizeChange(current, size) {
    setPerPage(size);
  }

  function onHandleDownloadReport() {
    const { page, perPage, ...params } = customerFilter;
    setNetworkCall(true);
    ReportService.getDownloadCustomers(params, user.token.token).then((res) => {
      if (res.data) {
        setNetworkCall(false);
        ReportService.downloadPDF(res.data, "customers-report.pdf");
        showNotification('Customer report downloaded successfully!', false);
      } else {
        setNetworkCall(false);
        message.error("Failed to download the report");
        return;
      }
    });
  }

  return (
    <section>
      <div className="flex flex-col">
        <CustomLoader />
        <Header title={""} menu={""} currentMenuKey={"T_6_S_6_L_4"} />
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Sale Report`} menu={constants.MENU.REPORTS[4]} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            {constants.MENU.REPORTS[4]}
          </h1>

          <CustomerReportComponent
            summaryData={customerSummary}
            reportData={customerReportList}
            setCustomerFilter={setCustomerFilter}
            handleFilterApply={onHandleFilterData}
            page={page}
            perPage={perPage}
            setPerPage={setPerPage}
            total={totalItem}
            handlePageChange={onHandlePageChange}
            handlePageSizeChange={onHandlePageSizeChange}
            setIsFilterClear={setIsFilterClear}
            handleDownload={onHandleDownloadReport}
            loading={networkCall}
          />
        </div>
      </div>
    </section>
  );
}
